import { tokens } from '@cast/design-system';
import { NodeResourceOfferingWithSoleTenancy } from '@cast/types';

export const nodeResourceOfferingLabelMap: Record<
  NodeResourceOfferingWithSoleTenancy,
  string
> = {
  'on-demand': 'On-demand',
  spot: 'Spot',
  fallback: 'Fallback',
  'sole-tenant': 'Sole tenant',
};

export const SOLE_TENANT_OFFERING_COLOR = tokens.theme.data.blue700;
